module.exports = __webpack_public_path__ + "static/img/生意参谋.9db7acf0.png";